// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__eVjg8","footer__content":"Footer_footer__content__wUEA5","footer__text":"Footer_footer__text__oew7C","site_url":"Footer_site_url__Zmm1g"};